import styled from 'styled-components';
import ListingHelper from '../../../../lib/listing-helper';

// TODO: Ideally this would be re-used from '../Shared/mobile-card-item'.
// The user of this component (mobile-bottom-sheet) uses the minified listing while the other has the full ListingDTO
interface ThirdWidthListingCardProps {
    listing: {
        id: number;
        authorName: string;
        title: string;
    };
    onSelectListing: (id: number) => void;
}

const ThirdWidthListingCard = (props: ThirdWidthListingCardProps) => {
    return (
        <MobileCarouselCard
            onClick={() => {
                props.onSelectListing(props.listing.id);
            }}
            key={props.listing.id}
        >
            <MobileCarouselCardImage src={ListingHelper.getPreviewUrlForListing(props.listing.id)} />
            <MobileCarouselCardTitle>{props.listing.title}</MobileCarouselCardTitle>
        </MobileCarouselCard>
    );
};

export default ThirdWidthListingCard;

export const MobileCarouselCard = styled.div`
    pointer-events: auto;
    margin: 4px;
    display: flex;
    flex-direction: column;
    width: calc(33vw - 8px);
    border: 1px solid white;
    border: 1px solid rgb(255 255 255 / 10%);
    border-radius: 6px;
    background-color: hsla(0, 100%, 100%, 0.01);
    box-shadow: 0px 6px 10px 0px hsla(0, 0%, 0%, 0.14), 0px 1px 18px 0px hsla(0, 0%, 0%, 0.12),
        0px 3px 5px -1px hsla(0, 0%, 0%, 0.2);
`;

export const MobileCarouselCardImage = styled.img`
    height: 90px;
    object-fit: cover;
    width: inherit;
    border-radius: 6px;
    background: black;
`;

export const MobileCarouselCardTitle = styled.div`
    margin: 3px 0;
    font-size: 1rem;
    width: inherit;
    color: rgba(255, 255, 255, 0.87);
    clear: both;
    overflow: hidden;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;
